module.exports = __webpack_public_path__ + "static/media/cw_forum_discussion_topic_h.bd879c78.png";